import React, { useState } from 'react';

import type User from '@this/domain/user/user2';
import TravelerInformation from '@this/domain/traveler_information';
import {
  WorkflowSelectorArrow,
  workflowSelectorTriggerStyle
} from '@this/components/shared/workflow_selector_appearance';
import MembersList from './members_list/members_list';

interface Props {
  travelers: TravelerInformation[];
  currentIndex: number;
  onSelect: (i: number, traveler: TravelerInformation) => void;
}

const SelectTravelers: React.FC<Props> = ({ travelers, currentIndex, onSelect }: Props) => {
  const [showMemberList, setShowMemberList] = useState(false);
  const traveler = travelers[currentIndex];
  const toggleMemberList = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    setShowMemberList(!showMemberList);
  };

  const handleMemberSelect = (member: User) => {
    setShowMemberList(false);
    const newTraveler = new TravelerInformation({});
    newTraveler.type = 'member';
    newTraveler.user = member;
    newTraveler.assignFromUser(member);
    onSelect(currentIndex, newTraveler);
  };

  return (
    <div className="select-travelers">
      <div className="select-travelers__wrapper">
        <div
          className="select-travelers__selected-list__item"
          style={workflowSelectorTriggerStyle}
          onClick={e => toggleMemberList(e)}
        >
          {traveler && (traveler.userId || traveler.user?.id) ? (
            <div className="members-list__item__info" style={{ flex: 1, minWidth: 0 }}>
              {traveler.user?.department?.name && (
                <p className="members-list__item-part">{traveler.user.department.name}</p>
              )}
              <p className="members-list__item-part">{traveler.name || traveler.userName}</p>
              <p className="members-list__item-part">({traveler.user?.email})</p>
              {traveler.user?.employeeNumber !== null && (
                <p className="members-list__item-part">[{traveler.user?.employeeNumber}]</p>
              )}
            </div>
          ) : (
            <p className="select-travelers__selected-list__message" style={{ flex: 1, minWidth: 0 }}>
              選択してください
            </p>
          )}
          <WorkflowSelectorArrow open={showMemberList} />
        </div>
        {showMemberList && <MembersList onSelect={handleMemberSelect} />}
      </div>
    </div>
  );
};

export default SelectTravelers;
